
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ir/stock/analyst-coverage",
      function () {
        return require("private-next-pages/ir/stock/analyst-coverage.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ir/stock/analyst-coverage"])
      });
    }
  